// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

// webgen:import { "defaultName": "Enums", "path": "../Enums" }
// webgen:import { "names": ["Writable"], "path": "type-fest" }

import { type PartialDeep, Writable } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import Enums from '../Enums';

export class QuoteStatus {
  readonly id: string;
  readonly name: string;
  readonly priority: number;
  readonly systemBehavior: Enums.QuoteStatusSystemBehavior;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.name = data.name === undefined ? '' : data.name;
    this.priority = data.priority === undefined ? 0 : data.priority;
    this.systemBehavior =
      data.systemBehavior === undefined
        ? Enums.QuoteStatusSystemBehavior.Draft
        : data.systemBehavior;
  }

  static zero(): QuoteStatus {
    const zeroValues: ExcludeMethodsDeep<QuoteStatus> = {
      id: NIL_UUID,
      name: '',
      priority: 0,
      systemBehavior: Enums.QuoteStatusSystemBehavior.Draft,
    };
    return new QuoteStatus(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  // Convenience methods for concisely identifying system behaviors.
  isDraft(): boolean {
    return this.systemBehavior === Enums.QuoteStatusSystemBehavior.Draft;
  }
  isApprovalRequest(): boolean {
    return this.systemBehavior === Enums.QuoteStatusSystemBehavior.ApprovalRequest;
  }
  isRejected(): boolean {
    return this.systemBehavior === Enums.QuoteStatusSystemBehavior.ApproverRejected;
  }
  isApprovedToSend(): boolean {
    return this.systemBehavior === Enums.QuoteStatusSystemBehavior.ApprovedToSend;
  }
  isSent(): boolean {
    return this.systemBehavior === Enums.QuoteStatusSystemBehavior.Sent;
  }
  isBuyerRejected(): boolean {
    return this.systemBehavior === Enums.QuoteStatusSystemBehavior.BuyerRejected;
  }
  isLost(): boolean {
    return this.systemBehavior === Enums.QuoteStatusSystemBehavior.Lost;
  }
  isBuyerAccepted(): boolean {
    return this.systemBehavior === Enums.QuoteStatusSystemBehavior.BuyerAccepted;
  }
  isArchived(): boolean {
    return this.systemBehavior === Enums.QuoteStatusSystemBehavior.Archived;
  }

  /**
   * policyApprovalsMet returns true if the status indicates that the quote has
   * approvals for all policy violations, so the quote can be (or has already
   * been) sent to the buyer.
   */
  policyApprovalsMet(): boolean {
    return (
      this.isApprovedToSend() ||
      this.isSent() ||
      this.isBuyerAccepted() ||
      this.isBuyerRejected() ||
      this.isLost()
    );
  }

  /**
   * Returns true if a user may set a quote's status to destination when the
   * quote's current status is this.
   *
   * When changing this method, consider whether you should also update the Go
   * implementation (named `AllowsUserStatusChange` at
   * internal/domain/quote.go).  The backend does have slightly different
   * requirements but in general these implementations should be similar.
   */
  canTransitionTo(destination: QuoteStatus): boolean {
    // Transitions between actual statuses are mostly restricted to same-
    // category statuses, because changing the approval workflow stage must
    // generally happen via structured actions where additional constraints
    // can be enforced by our backend.
    //
    // Exceptions:
    //  - Quotes may be freely moved "backward" from isApprovalRequest to isDraft.
    //  - Quotes may be freely moved "forward" from isApprovedToSend to sent,
    //    buyer accepted, or buyer rejected.
    //  - The backend also freely allows quotes to move from isDraft
    //    to isApprovalRequest; on the frontend that is a "structured" action that
    //    simply consists of a dedicated "send for review" button.
    if (this.isDraft() && destination.isDraft()) {
      return true;
    }
    if (this.isApprovalRequest() && (destination.isDraft() || destination.isApprovalRequest())) {
      return true;
    }
    if (this.isRejected() && destination.isRejected()) {
      return true;
    }
    if (
      this.isApprovedToSend() &&
      (destination.isApprovedToSend() ||
        destination.isSent() ||
        destination.isBuyerAccepted() ||
        destination.isBuyerRejected())
    ) {
      return true;
    }
    if (
      (this.isSent() || this.isBuyerAccepted() || this.isBuyerRejected()) &&
      (destination.isSent() || destination.isBuyerAccepted() || destination.isBuyerRejected())
    ) {
      return true;
    }
    if ((this.isSent() || this.isBuyerRejected()) && destination.isLost()) {
      return true;
    }
    if (this.isLost() && destination.isLost()) {
      return true;
    }
    // Archived statuses are dead-ends and accessible from any other status.
    // This also covers the only transition out of Lost (Lost -> Archived).
    return destination.isArchived();
  }

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type QuoteStatusWireFormat = {
  id: string;
  name: string;
  priority: number;
  systemBehavior: string;
};

type NewQuoteStatusProps = PartialDeep<QuoteStatus, { recurseIntoArrays: true }>;
export const NewQuoteStatus: (props: NewQuoteStatusProps) => QuoteStatus = (props) =>
  new QuoteStatus(props);

type NewQuoteStatusFromWireFormatProps = PartialDeep<
  QuoteStatusWireFormat,
  { recurseIntoArrays: true }
>;
export const NewQuoteStatusFromWireFormat: (
  props: NewQuoteStatusFromWireFormatProps,
) => QuoteStatus = (props) => new QuoteStatus(props);
